export default Object.freeze({
  GENERAL: {
    IMAGE: 1,
    MOVIE: 2,
    MOVIE_SCREENSHOT: 6,
  },
});
